import React from 'react';
import { PRICE } from './salesData';
interface PriceBlockProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  layout?: 'stack' | 'inline';
}
const CURRENT_SIZE = {
  sm: 'text-3xl',
  md: 'text-4xl',
  lg: 'text-5xl sm:text-6xl'
};

/** Precio anterior tachado + precio actual en dorado. */
export function PriceBlock({
  className = '',
  size = 'md',
  layout = 'stack'
}: PriceBlockProps) {
  return <div className={className} data-id="element-151" data-mp="1k5nmjqtom62f">
      <div className={`flex flex-wrap items-baseline gap-x-3 gap-y-1 ${layout === 'inline' ? 'justify-start' : 'justify-start'}`} data-id="element-152" data-mp="1k6yqprr1hfu2">
        <span className="font-display text-base text-ash/80 line-through decoration-keto-pizza decoration-2" data-id="element-153" data-mp="1twi5ombmspjn">
          {PRICE.previous}
        </span>
        <span className={`font-condensed leading-none text-gold ${CURRENT_SIZE[size]}`} data-id="element-154" data-mp="1p3p2w3zq3ra7">
          {PRICE.current}
        </span>
      </div>
      <p className="mt-2 text-[0.78rem] text-ash" data-id="element-155" data-mp="whmiau3jdbst">{PRICE.note}</p>
    </div>;
}